"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnEnter_SpawnActorsRoomScript = void 0;
const Registries_1 = require("../../state/Registries");
const mkDefaultMeta = () => ({
    activated: false
});
let OnEnter_SpawnActorsRoomScript = class OnEnter_SpawnActorsRoomScript {
    run(sequence, container, state, args) {
        state.meta.onEnter = state.meta.onEnter || mkDefaultMeta();
        if (state.meta.onEnter.activated) {
            return;
        }
        state.meta.onEnter.activated = true;
        for (const actor of args.actors) {
            const id = container.addActor(sequence, actor);
            state.actors.push(id);
        }
    }
};
OnEnter_SpawnActorsRoomScript = __decorate([
    Registries_1.RoomScripts.register("OnEnter_SpawnActors")
], OnEnter_SpawnActorsRoomScript);
exports.OnEnter_SpawnActorsRoomScript = OnEnter_SpawnActorsRoomScript;
